export default __webpack_public_path__ + "static/media/TalentSoft_log_bleu.cceee4f0.png";